import _defineProperty2 from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './RadioButtonsList.css';
import React, { useEffect, useState } from 'react';
var RadioButtonsList = function RadioButtonsList(props) {
  var _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    _props$value = props.value,
    contextValue = _props$value === void 0 ? '' : _props$value,
    _props$label = props.label,
    label = _props$label === void 0 ? 'label' : _props$label,
    _props$name = props.name,
    name = _props$name === void 0 ? 'name' : _props$name,
    updateContext = props.updateContext,
    _props$rtl = props.rtl,
    rtl = _props$rtl === void 0 ? false : _props$rtl,
    _props$patternInvalid = props.patternInvalidMessage,
    patternInvalidMessage = _props$patternInvalid === void 0 ? 'validateError' : _props$patternInvalid,
    _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options,
    validate = props.validate,
    isBoolean = props.isBoolean;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    inValid = _useState2[0],
    setInValid = _useState2[1];
  var onChangeEvent = function onChangeEvent(value) {
    var stringValue = isBoolean ? value : value.toString();
    if (stringValue.length) required && setInValid(!(stringValue && stringValue.length));
    updateContext(_defineProperty2({}, name, _objectSpread(_objectSpread({}, props), {}, {
      valid: required && !!stringValue,
      value: stringValue
    })));
  };
  useEffect(function () {
    if (validate) {
      var stringValue = contextValue.toString();
      required && setInValid(!(stringValue && stringValue.length));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validate]);
  return /*#__PURE__*/React.createElement("fieldset", {
    className: "".concat(rtl ? rtlStyles : ltrStyles, " ").concat(styles)
  }, /*#__PURE__*/React.createElement("legend", {
    className: "accessibility-hidden-text"
  }, label), label && /*#__PURE__*/React.createElement("p", {
    className: "body-small wiz__label"
  }, label, required && /*#__PURE__*/React.createElement("span", {
    className: "form-label__marker"
  }, " * ")), /*#__PURE__*/React.createElement("div", {
    className: "d-flex "
  }, options.map(function (props, index) {
    var lookupId = props.lookupId,
      name = props.name;
    var label = rtl ? name.ar || '' : name.en || '';
    var checked = isBoolean ? contextValue == lookupId : contextValue.length && contextValue.toString() == lookupId;
    return /*#__PURE__*/React.createElement("span", {
      key: lookupId,
      className: "form-label__container"
    }, /*#__PURE__*/React.createElement("input", {
      className: "fp__radio ".concat(inValid ? ' invalid-field' : ''),
      type: "radio",
      onChange: function onChange() {
        onChangeEvent(lookupId);
      },
      tabIndex: 0,
      onKeyPress: function onKeyPress(event) {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          event.currentTarget.checked = !event.currentTarget.checked;
          event.preventDefault();
          onChangeEvent(lookupId);
        }
      },
      checked: checked,
      name: label,
      id: label,
      value: lookupId
    }), label && /*#__PURE__*/React.createElement("label", {
      htmlFor: label,
      className: "form-label__radio "
    }, label));
  })), inValid && /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("p", {
    className: "text-input__error"
  }, patternInvalidMessage)));
};
var styles = "si1keph";
var ltrStyles = "l12syft1";
var rtlStyles = "rhoh7s6";
export default RadioButtonsList;